// core and npm packages
import React from "react";
import { Accordion, Container, Form } from "react-bootstrap";

// asset files
import "./Dashboard.css";

// Components
import VideoRoom from "./VideoRoom";
import AudioRooms from "./AudioRooms";
import AppLoader from "../AppLoader/AppLoader";
import LocationDetailsCard from "./LocationDetailsCard";

// Core
import { GetApiMethod } from "../../core/services/apiService";
import { GetWebSocketConnection, stopNotificationRing, removeNotification, addParticipantVideoCall, numberOnly, GetTenantId, loggerHelper, infoUserForSocketIssue, checkCallSid } from "../../core/services/sharedService";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";
import { showToaster } from "../../core/redux/toastSlice";
import { setPreventNavigation } from "../../core/redux/authSlice";
import { DtoLocationDetails, DtoIncomingNotification, DtoLocationData, DtoAgentStatus } from "../../core/dto/dashboard.dto";
import { setAgentNotifications, setCallAccepted, setDefaultActiveKeys, setInCallNotificationIdRef, setInDirectCall, terminateManualVideoCall, acceptIncomingVoiceCall, serverConfirmedVoiceCallAccept, setInComingCallInstanceTrigger, setHoldCallDetails, setHoldCallDetailsONTenantEnd, setOutBoundCallLocationDetails, setAppLoader, playPauseRinger, updateDndList, setVideoRoomDetails, updateVideoRoomDetailsAddParticipantButton, triggerVideoCallEndFunction, setRestartMotionStateLocationData, removeLocIdFromRestartMotionStateData, setInHandOffCall, setAudioCallErrorMessage, removeInComingVoiceCallNotification, terminateVoiceCall, setOutBoundCallCustomerDetails } from "../../core/redux/notificationsSlice";
import AppModal from "../AppModal/AppModal";
import ZoomVideoRoom from "./ZoomVideoRoom";
import { checkAbilityToUseZOOM } from "../../core/services/sharedService";
import VoiceCallCustomerDetails, { VoiceCallCustomerDetailsRef } from "../Common/VoiceCallCustomerDetails";
import VideoCallCustomerDetails, { VideoCallCustomerDetailsRef } from "../Common/VideoCallCustomerDetails";

const Dashboard = () => {
    // redux variables
    let settingsState = useAppSelector((state) => state.settings);
    let LoginUserDetails = useAppSelector((state) => state.auth.users);
    let authState = useAppSelector((state) => state.auth);
    let notificationsSliceSelector = useAppSelector(
        (state) => state.agentNotification
    );
    const dispatch = useAppDispatch();
    const tenantID = GetTenantId();

    // socket and twilio variables
    const socket = GetWebSocketConnection()!;
    const socketIssueAlertRef = React.useRef<boolean>(false);
    const [agentLogo, setAgentLogo] = React.useState<string>();
    const [agentId, setAgentId] = React.useState<string>();
    const [currentAgentName, setCurrentAgentName] = React.useState<string>("");
    const [filteredLocationsData, setFilteredLocationsData] = React.useState<DtoLocationData>();
    const [showLoader, setShowLoader] = React.useState<boolean>(false);
    const [onlineLocations, setOnlineLocations] = React.useState<{ "online": string[], "busy": string[], "notified": string[], "dnd": string[], "offline": string[], "dndTimeStamp": any, "dndDetails": string[] }>({ "online": [], "busy": [], "notified": [], "dnd": [], "offline": [], "dndTimeStamp": [], "dndDetails": [] });
    const [agentStatus, setAgentStatus] = React.useState<{ [index: string]: DtoAgentStatus }>({});
    const [twilioToken, setTwilioToken] = React.useState<string | undefined | null>(null);
    const [localParticipantDetails, setLocalParticipantDetails] = React.useState(null);
    const [inCallLocationId, setInCallLocationId] = React.useState<string>();
    const [inCallNotificationId, setInCallNotificationId] = React.useState<string>();
    const [inHoldDuration, setInHoldDuration] = React.useState<number | undefined>();
    const [callTriggeredFlag, setCallTriggeredFlag] = React.useState<boolean>(false);
    const [isQrScanNotification, setIsQrScanNotification] = React.useState<boolean>(false);

    const terminateVideoCallRef = React.useRef<Function>(null);
    const holdVideoCallRef = React.useRef<Function>(null);
    const voice_call_type = 'voice';
    const video_call_type = 'video';

    const [showDndPopUp, setShowDndPopUp] = React.useState<boolean>(false);
    const [dnDLocationID, setDnDLocationID] = React.useState("");
    const [dnDNotificationID, setNotificationID] = React.useState("");
    const [zoomVideoRoomName, setZoomVideoRoomName] = React.useState("");
    const [conference_call, setConference_call] = React.useState<boolean | undefined>(false);

    // Voice call customer details popup state
    const [showVoiceCallCustomerDetails, setShowVoiceCallCustomerDetails] = React.useState(false);
    const [voiceCallDetailsData, setVoiceCallDetailsData] = React.useState<any>(null);
    const [voiceCallCountdown, setVoiceCallCountdown] = React.useState<number>(0);
    const voiceCallCustomerDetailsRef = React.useRef<VoiceCallCustomerDetailsRef>(null);
    const voiceCallPopupTimerRef = React.useRef<ReturnType<typeof setTimeout>>();
    const voiceCallEndTriggeredRef = React.useRef<boolean>(false);
    const voiceCallCountdownIntervalRef = React.useRef<ReturnType<typeof setInterval>>();
    const voiceCallAutoSubmitTimerRef = React.useRef<ReturnType<typeof setTimeout>>();
    const voiceCallClearDataTimerRef = React.useRef<ReturnType<typeof setTimeout>>();
    const voiceCallDetailsDataRef = React.useRef<any>(null);
    const showVoiceCallCustomerDetailsRef = React.useRef<boolean>(false);

    // Video call customer details popup state
    const [showVideoCallCustomerDetails, setShowVideoCallCustomerDetails] = React.useState(false);
    const [videoCallDetailsData, setVideoCallDetailsData] = React.useState<any>(null);
    const [videoCallCountdown, setVideoCallCountdown] = React.useState<number>(0);
    const videoCallCustomerDetailsRef = React.useRef<VideoCallCustomerDetailsRef>(null);
    const videoCallPopupTimerRef = React.useRef<ReturnType<typeof setTimeout>>();
    const videoCallEndTriggeredRef = React.useRef<boolean>(false);
    const videoCallCountdownIntervalRef = React.useRef<ReturnType<typeof setInterval>>();
    const videoCallAutoSubmitTimerRef = React.useRef<ReturnType<typeof setTimeout>>();
    const videoCallClearDataTimerRef = React.useRef<ReturnType<typeof setTimeout>>();
    const videoCallDetailsDataRef = React.useRef<any>(null);
    const showVideoCallCustomerDetailsRef = React.useRef<boolean>(false);

    const showDndModal = (location: string, notification_id?: string) => {
        setShowDndPopUp(true);
        setDnDLocationID(location);
        notification_id && setNotificationID(notification_id);
    }

    React.useEffect(() => {
        if (notificationsSliceSelector.callAccepted) {
            dispatch(setPreventNavigation(true));
        } else {
            dispatch(setPreventNavigation(false));
        }
    }, [notificationsSliceSelector.callAccepted, dispatch]);

    const logger = React.useCallback((message: String, details: any) => {
        loggerHelper(message, details);
    }, []);

    const getUserMediaDetails = React.useCallback(async () => {
        try {
            // Checking the camera and  microphone permission.
            const constraints = { audio: true, video: true };
            await navigator.mediaDevices.getUserMedia(constraints).then((mediaStream) => {
                mediaStream.getTracks().forEach(function (track) {
                    track.stop();
                });
            });
            return true;
        } catch (error) {
            if (error instanceof DOMException) {
                if (error.name === 'NotAllowedError') {
                    window.confirm('Permission denied for Camera/Microphone. Kindly enable it.');
                    logger('Device not connected -- NotAllowedError', error);
                    return false;
                }
                else if (error.name === 'NotFoundError') {
                    window.confirm('Camera/Microphone are not found.');
                    logger('Device not connected -- NotFoundError', error);
                    return false;
                }
                else if (error.name === 'NotReadableError') {
                    window.confirm('Camera/Microphone is busy.');
                    logger('Device not connected -- NotReadableError', error);
                    return false;
                }
                return true;
            }
            return true;
        }
    }, [logger]);

    React.useEffect(() => {
        getUserMediaDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkLocationHasNotification = React.useCallback(() => {
        if (notificationsSliceSelector.locationsData) {
            let filteredData: DtoLocationData = {
                primary: [],
                secondary: [],
                others: [],
            };
            Object.keys(notificationsSliceSelector.locationsData).forEach((locationType: string) => {
                const filteredLocationDetails: DtoLocationDetails[] = [];
                const locationArray = notificationsSliceSelector.locationsData[locationType as keyof DtoLocationData];

                // Skip if the location array doesn't exist (e.g., hiddenLocations might be undefined)
                if (locationArray && Array.isArray(locationArray)) {
                    locationArray.forEach(
                        (locationInfo: DtoLocationDetails) => {
                            if (notificationsSliceSelector.inDirectCall && !notificationsSliceSelector.notificationData.find(
                                (x: DtoIncomingNotification) =>
                                    (x.locationId === locationInfo._id && x.call_type === video_call_type)
                            )) {
                                filteredLocationDetails.push(locationInfo);
                            } else if (notificationsSliceSelector.notificationData.find(
                                (x: DtoIncomingNotification) =>
                                    (x.locationId === locationInfo._id)
                            )) {
                                filteredLocationDetails.push(locationInfo);
                            } else {
                                if (
                                    !notificationsSliceSelector.notificationData.find(
                                        (x: DtoIncomingNotification) =>
                                            x.locationId === locationInfo._id
                                    )
                                ) {
                                    filteredLocationDetails.push(locationInfo);
                                }
                            }
                        }
                    );
                }
                filteredData[locationType as keyof DtoLocationData] = [
                    ...filteredLocationDetails,
                ];
            });
            setFilteredLocationsData({ ...filteredData });
        }
    }, [notificationsSliceSelector.notificationData, notificationsSliceSelector.inDirectCall, notificationsSliceSelector.locationsData]);

    React.useEffect(() => {
        checkLocationHasNotification();
    }, [checkLocationHasNotification]);

    // const getLocationStatus = React.useCallback((locationStatus: [{ kioskID: string, locationId: string, status: string, tenantID: string, dnd: string }]) => {
    //     let status: {
    //         "online": string[],
    //         "busy": string[],
    //         "notified": string[],
    //         "dnd": string[],
    //         "offline": string[],
    //         "dndTimeStamp": any,
    //         "dndDetails": any
    //     } = { "online": [], "busy": [], "notified": [], "dnd": [], "dndTimeStamp": [], 'dndDetails': [], 'offline': [] };
    //     logger(`kiosks_status result from server -`, { "locationStatus": locationStatus, "agentId": (LoginUserDetails?._id || "not available") });
    //     locationStatus.forEach((location: { kioskID: string, locationId: string, status: string, tenantID: string, dnd: string }) => {
    //         if ("locationId" in location && location.locationId && "status" in location && location.status === "online") {
    //             status["online"].push(location.locationId);
    //         } else if ("locationId" in location && location.locationId && "status" in location && location.status === "busy") {
    //             status["busy"].push(location.locationId);
    //         } else if ("locationId" in location && location.locationId && "status" in location && location.status === "notified") {
    //             status["notified"].push(location.locationId);
    //         } else if ("locationId" in location && location.locationId && "status" in location && location.status === "dnd") {
    //             status["dnd"].push(location.locationId);
    //             status["dndTimeStamp"].push(location.dnd);
    //             status['dndDetails'].push({ [location.locationId]: location.dnd });
    //         } else if ("locationId" in location && location.locationId && "status" in location && location.status === "offline") {
    //             status["offline"].push(location.locationId);
    //         }
    //     });
    //     setOnlineLocations(status);
    //     logger("Final status obj after formatting", status);
    // }, []);

    React.useEffect(() => {
        if (settingsState.logo) {
            setAgentLogo(settingsState.logo);
        }
    }, [settingsState.logo]);

    React.useEffect(() => {
        if (LoginUserDetails._id) {
            setAgentId(LoginUserDetails._id);
            setCurrentAgentName(LoginUserDetails.name && (LoginUserDetails.name[0].toUpperCase() + LoginUserDetails.name.slice(1)));
        }
    }, [LoginUserDetails._id, LoginUserDetails.name]);

    React.useEffect(() => {
        if (socket) {
            // Added kiosk status updation logic in App.tsx
            // socket.emit("get_kiosk_status", async (response: any) => { });
            // socket.on("kiosks_status", getLocationStatus);
            socket.on("join_room", async (message) => {
                dispatch(setVideoRoomDetails(message));
                setTwilioToken(message.token);
                logger(`success in join_room token`, message.token);
            });
            socket.on("agents_status", async (res: DtoAgentStatus[]) => {
                let agentStatusRes: { [index: string]: DtoAgentStatus } = {};
                res.forEach((element: DtoAgentStatus) => {
                    if (element.email && tenantID === element.tenantID) {
                        agentStatusRes[element.email] = element;
                    }
                });
                setAgentStatus(agentStatusRes);
            });
            socket.on("connect_error", (err) => {
                infoUserForSocketIssue(err);
            });
            socket.on("disconnect", (reason, details) => {
                infoUserForSocketIssue([reason, details], false, agentId);
            });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket]);

    React.useEffect(() => {
        let status: {
            "online": string[],
            "busy": string[],
            "notified": string[],
            "dnd": string[],
            "offline": string[],
            "dndTimeStamp": any,
            "dndDetails": any
        } = { "online": [], "busy": [], "notified": [], "dnd": [], "dndTimeStamp": [], 'dndDetails': [], 'offline': [] };
        // logger(`kiosks_status result from server -`, { "locationStatus": authState?.allKioskStatusDetails, "agentId": (LoginUserDetails?._id || "not available") });
        // console.log(`kiosks_status result from server -`, { "locationStatus": authState?.allKioskStatusDetails, "agentId": (LoginUserDetails?._id || "not available") });

        authState?.allKioskStatusDetails?.forEach((location: any) => {
            if ("locationId" in location && location.locationId && "status" in location && location.status === "online") {
                status["online"].push(location.locationId);
            } else if ("locationId" in location && location.locationId && "status" in location && location.status === "busy") {
                status["busy"].push(location.locationId);
            } else if ("locationId" in location && location.locationId && "status" in location && location.status === "notified") {
                status["notified"].push(location.locationId);
            } else if ("locationId" in location && location.locationId && "status" in location && location.status === "dnd") {
                status["dnd"].push(location.locationId);
                status["dndTimeStamp"].push(location.dnd);
                status['dndDetails'].push({ [location.locationId]: location.dnd });
            } else if ("locationId" in location && location.locationId && "status" in location && location.status === "offline") {
                status["offline"].push(location.locationId);
            }
        });
        setOnlineLocations(status);
        logger("Final status obj after formatting", status);
        // console.log("Final status obj after formatting", status);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState.allKioskStatusDetails]);

    React.useEffect(() => {
        let agentStatusRes: { [index: string]: DtoAgentStatus } = {};
        authState.allAgentStatusDetails.forEach((element: DtoAgentStatus) => {
            if (element.email && tenantID === element.tenantID) {
                agentStatusRes[element.email] = element;
            }
        });
        setAgentStatus(agentStatusRes);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState.allAgentStatusDetails])

    // emit the join_call event when user clicks on join call
    const sendMessage = async (notificationData: DtoIncomingNotification, call_type: string, conference_call?: boolean, room_name?: string, tenant_room_sid?: string) => {
        logger(`Agent sendMessage payload -`, { "notificationData": notificationData, "call_type": call_type, "conference_call": conference_call, "room_name": room_name, "tenant_room_sid": tenant_room_sid, "agentId": agentId });
        dispatch(setCallAccepted(true));
        dispatch(setInCallNotificationIdRef((notificationData && notificationData.notificationId) ? notificationData.notificationId : notificationData.locationId));
        setShowLoader(true);
        //  Checking for Local or manual call.
        if (Object.keys(notificationData).length === 1 && notificationData.call_type === voice_call_type) {
            socket.emit(
                "join_call",
                {
                    locationId: notificationData.locationId,
                },
                async (response: any) => {
                    setShowLoader(false);
                    // Checking for location or kiosk is notified or online status or not.
                    if ("data" in response && response["data"] && "error" in response["data"] && response["data"]["error"] && "status" in response["data"]["error"] && response["data"]["error"]["status"] && response["data"]["error"]["status"] === "join_call_failed" && response["data"]["error"]["message"]) {
                        dispatch(showToaster(
                            {
                                dialogBgColor: 'bg-danger',
                                dialogMsg: response["data"]["error"]["message"],
                                showDialog: true,
                                timer: '5000'
                            }
                        ));
                    } else {
                        dispatch(setInDirectCall(true));
                        setFilteredLocationsData((oldArray: any) => {
                            Object.keys(oldArray).forEach((locationType: any) => {
                                let notificationIndex: number = oldArray[locationType].findIndex((location: any) => location._id === notificationData.locationId);
                                if (notificationIndex > -1 && oldArray && oldArray[locationType] && oldArray[locationType][notificationIndex]) {
                                    let updateNotificationData = { ...oldArray[locationType][notificationIndex] };
                                    updateNotificationData.callAccepted = true;
                                    oldArray[locationType][notificationIndex] = { ...updateNotificationData };
                                }
                            });
                            return oldArray;
                        })
                        response.data.addParticipant = true;
                        dispatch(setVideoRoomDetails(response.data));
                        setTwilioToken(response.data.token);
                        setInCallNotificationId(notificationData.notificationId);
                        setInCallLocationId(notificationData.locationId);
                    }
                }
            );
        } else {
            // Incoming call from server.
            if (notificationData.tenant_triggered) {
                setIsQrScanNotification(true);
            } else {
                setIsQrScanNotification(false);
            }
            const oldArray: Array<DtoIncomingNotification> = [...notificationsSliceSelector.notificationData];
            let notificationIndex: number;
            if (conference_call || oldArray.filter((item: any) => (item.room_name && item.room_sid))) {
                notificationIndex = oldArray.findIndex((item) => notificationData.notificationId && notificationData.notificationId === item.notificationId);
            } else {
                notificationIndex = oldArray.findIndex((item) => notificationData.kioskId && notificationData.kioskId === item.kioskId);
            }
            if (oldArray && oldArray[notificationIndex] && "callback" in oldArray[notificationIndex] && oldArray[notificationIndex].callback && oldArray[notificationIndex].callback !== undefined) {
                const callBackFunction = oldArray[notificationIndex].callback;
                if (callBackFunction) {
                    callBackFunction(true);
                }
            }
            if (oldArray && oldArray[notificationIndex]) {
                let updateNotificationData = { ...oldArray[notificationIndex] };
                updateNotificationData.callAccepted = true;
                oldArray[notificationIndex] = { ...updateNotificationData };
            }
            dispatch(setAgentNotifications([...oldArray]));
            let joinCallEmitData: any = {
                locationId: notificationData.locationId,
                kioskId: notificationData.kioskId!,
                notificationId: notificationData.notificationId,
                notified_agents: notificationData.notified_agents,
                tenant_triggered: notificationData.tenant_triggered ? notificationData.tenant_triggered : false,
                roomSid: notificationData.room_sid ? notificationData.room_sid : false,
                roomName: notificationData.room_name ? notificationData.room_name : false,
                answeredAgentName: currentAgentName,
                sessionName: notificationData.sessionName,
                userName: agentId
            }
            if (conference_call) {
                joinCallEmitData['conference_call'] = true;
                joinCallEmitData['roomName'] = room_name;
                joinCallEmitData['room_sid'] = tenant_room_sid;
            }
            logger(`Event on before join_room emit`, joinCallEmitData);
            socket.timeout(30000).emit(
                "join_call",
                joinCallEmitData,
                async (error: any, response: any) => {
                    setCallTriggeredFlag(false);
                    setShowLoader(false);
                    logger(`Event on join_room response`, response);
                    if ((response && response.data && response.data.error && response.data.error.status === 'join_call_failed') || (error)) {
                        dispatch(showToaster(
                            {
                                dialogBgColor: 'bg-danger',
                                dialogMsg: (response && response.data && response.data.error && response.data.error.message) ? response.data.error.message : 'Something went wrong',
                                showDialog: true,
                                timer: '10000'
                            }
                        ));
                        terminateVideoCall((notificationData && notificationData.notificationId) ? notificationData.notificationId : notificationData.locationId, false, ((notificationData && notificationData.notificationId)) ? 'no' : 'yes');
                    } else {
                        if (conference_call) {
                            response.data.addParticipant = false;
                        } else {
                            response.data.addParticipant = true;
                        }
                        dispatch(setVideoRoomDetails(response.data));
                        setTwilioToken(response.data.token);
                        setInCallNotificationId(notificationData.notificationId);
                        setInCallLocationId(notificationData.locationId);
                    }
                }
            );
        }
    };

    const sendVoiceCallMessage = React.useCallback(() => {
        // dispatch(setInCallNotificationIdRef(notificationData.notificationId));
        // emit the join_call event when user clicks on join call
        dispatch(setInComingCallInstanceTrigger(false));
        if (notificationsSliceSelector.audioNotificationData) {
            logger(`Agent sendVoiceMessage payload -`, { "agentId": agentId, "call_sid": notificationsSliceSelector.audioNotificationData.call_sid });
            socket.emit(
                "join_voice_call",
                {
                    locationId: notificationsSliceSelector.audioNotificationData.locationId,
                    application_sid: notificationsSliceSelector.audioNotificationData.application_sid,
                    contact_from: notificationsSliceSelector.audioNotificationData.contact_from,
                    notificationId: notificationsSliceSelector.audioNotificationData.notificationId,
                    notified_agents: notificationsSliceSelector.audioNotificationData.notified_agents,
                    call_sid: notificationsSliceSelector.audioNotificationData.call_sid,
                    userName: agentId
                },
                async (response: any) => {
                    loggerHelper("join_voice_call response from server", response);
                    if ((response && response.data && response.data.error && response.data.error.status === 'join_call_failed')) {
                        dispatch(showToaster(
                            {
                                dialogBgColor: 'bg-success',
                                dialogMsg: response?.data?.error?.message ?? 'Something went wrong in the voice call response',
                                showDialog: true,
                                timer: '10000'
                            }
                        ));
                        // Remove the notification if call answered by another agent
                        dispatch(terminateVoiceCall({
                            callerId:
                                response.data?.call_sid,
                            disconnectCall:
                                false,
                            terminate_call_request_from: "join_call_failed_by_server"
                        }));
                    } else if (response && response.data && response.data.call_sid) {
                        // Server confirmed this agent as the lock winner — NOW accept the Twilio call
                        dispatch(serverConfirmedVoiceCallAccept(checkCallSid(response.data.call_sid) as string));
                    }
                }
            );
        }
    }, [agentId, dispatch, logger, notificationsSliceSelector.audioNotificationData, socket]);

    React.useEffect(() => {
        if (notificationsSliceSelector.audioCallError) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Something went wrong hence disconnecting the call, Please try again.",
                    showDialog: true,
                    timer: '5000'
                }
            ));
            dispatch(setAudioCallErrorMessage({ 'audioCallError': false }));
        }
        // Acknowledge the agent that call has been answered by another agent
        if (notificationsSliceSelector.multipleAgentAnsweredCallError) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-success',
                    dialogMsg: "The call has been answered by another agent",
                    showDialog: true,
                    timer: '5000'
                }
            ));
            dispatch(removeInComingVoiceCallNotification(notificationsSliceSelector.answeredCallSidBySomeOtherAgent[0]));
            dispatch(setAudioCallErrorMessage({ 'multipleAgentAnsweredCallError': false }));
        }
    }, [notificationsSliceSelector.audioCallError, notificationsSliceSelector.multipleAgentAnsweredCallError]);

    // Sending out bound voice call Acknowledgement
    const sendOutBoundVoiceCallSocketEmit = React.useCallback((outBoundCallData: any) => {
        // emit the join_call event when user clicks on join call
        if (outBoundCallData) {
            socket.emit(
                "join_voice_call",
                {
                    call_from: outBoundCallData?.From, call_to: outBoundCallData?.To, location_id: outBoundCallData?.locationId, callerBound: outBoundCallData?.callerBound, agent_email: outBoundCallData?.agentEmail, agent_to_email: outBoundCallData?.agentToEmail, call_sid: outBoundCallData?.callSid
                },
                async (response: any) => {
                    console.log(response, "voice call token");
                    // Store customer details from outbound call response
                    // Accept both empty array (new customer) and array with data (existing customer)
                    if (response && response.data && response.data.customerDetails !== undefined) {
                        dispatch(setOutBoundCallCustomerDetails(response.data.customerDetails));
                    }
                }
            );
        }
    }, [socket, dispatch]);

    const restartMotionDetection = (locationId: string, notificationsId?: string) => {
        dispatch(setCallAccepted(false));
        let existingRestartMotionLocationIds: string[] = notificationsSliceSelector.restartMotionStateLocationId ? notificationsSliceSelector.restartMotionStateLocationId : [];
        dispatch(setRestartMotionStateLocationData([...existingRestartMotionLocationIds, locationId]));

        if (notificationsId) {
            socket.emit("restart_kiosk", {
                locationId: locationId,
                notificationId: notificationsId,
            }, async (response: any) => {
                dispatch(removeLocIdFromRestartMotionStateData(response.location_id));
            });
        }
        else {
            socket.emit("restart_kiosk", {
                locationId: locationId,
            }, async (response: any) => {
                dispatch(removeLocIdFromRestartMotionStateData(response.location_id));
            });
        }
        removeNotification(notificationsId);
    };

    const getVoiceCallSid = React.useCallback(() => {
        if (notificationsSliceSelector.callDetails) {
            return notificationsSliceSelector.callDetails['customParameters'].get('call_sid');
        } else if (notificationsSliceSelector.outBoundCallConnection) {
            return notificationsSliceSelector.outBoundCallConnection.parameters.CallSid;
        } else {
            return null;
        }
    }, [notificationsSliceSelector.callDetails, notificationsSliceSelector.outBoundCallConnection])

    const putCallOnHold = React.useCallback((callType: string) => {
        if (callType === video_call_type) {
            setInHoldDuration(undefined);
            socket.emit("hold_call", {
                call_type: video_call_type,
                room_name: notificationsSliceSelector.videoRoomDetails?.roomName,
                room_sid: notificationsSliceSelector.videoRoomDetails?.room_sid
            }, async (response: any) => { });
            dispatch(
                setHoldCallDetails(
                    {
                        token: twilioToken ? twilioToken : undefined,
                        roomData: notificationsSliceSelector.videoRoomDetails,
                        inCallNotificationId: inCallNotificationId,
                        inCallLocationId: inCallLocationId,
                        inCallRefId: notificationsSliceSelector.inCallNotificationIdRef,
                    }
                )
            );
            dispatch(setCallAccepted(false));
            setTwilioToken(null);
            dispatch(setInCallNotificationIdRef(undefined));
            dispatch(setInDirectCall(false));
            setInCallNotificationId(undefined);
            setInCallLocationId(undefined);
            dispatch(setVideoRoomDetails(undefined));
            if (holdVideoCallRef && holdVideoCallRef.current) {
                holdVideoCallRef.current();
            }
        } else if (callType === voice_call_type) {
            setInHoldDuration(undefined);
            dispatch(setAppLoader(true));
            const callTimer = notificationsSliceSelector.audioCallTimer;
            const callHoldTime = new Date();
            socket.emit("hold_call", {
                call_type: callType,
                call_sid: checkCallSid(getVoiceCallSid())
            }, async (response: any) => {
                dispatch(setAppLoader(false));
                if (response.hold) {
                    dispatch(
                        setHoldCallDetails(
                            {
                                token: undefined,
                                roomData: undefined,
                                inCallNotificationId: inCallNotificationId,
                                inCallLocationId: inCallLocationId,
                                inCallRefId: notificationsSliceSelector.inCallNotificationIdRef,
                                callSid: checkCallSid(getVoiceCallSid()),
                                callTimer: callTimer,
                                callHoldTime: String(callHoldTime),
                                addParticipant: ((notificationsSliceSelector.audioNotificationData && !notificationsSliceSelector.audioNotificationData.third_agent && notificationsSliceSelector.audioNotificationData && notificationsSliceSelector.audioNotificationData.addParticipant) || (notificationsSliceSelector.outBoundCallLocationDetails && notificationsSliceSelector.outBoundCallLocationDetails.addParticipant)) ? true : false
                            }
                        )
                    );
                    dispatch(setCallAccepted(false));
                    dispatch(setInCallNotificationIdRef(undefined));
                    dispatch(setInDirectCall(false));
                    dispatch(setOutBoundCallLocationDetails(undefined));
                    setInCallNotificationId(undefined);
                    setInCallLocationId(undefined);
                } else {

                    dispatch(showToaster(
                        {
                            dialogBgColor: 'bg-danger',
                            dialogMsg: response.message ? response.message : "Invalid request",
                            showDialog: true,
                            timer: '5000'
                        }
                    ));
                }
            });
        }
    }, [dispatch, getVoiceCallSid, inCallLocationId, inCallNotificationId, notificationsSliceSelector, socket, twilioToken]);

    const resumeVideoCall = React.useCallback((call_type: string) => {
        let call_sid;
        if (call_type === video_call_type) {
            if (notificationsSliceSelector.holdCallDetails) {
                setTwilioToken(notificationsSliceSelector.holdCallDetails.token);
                dispatch(setInCallNotificationIdRef(notificationsSliceSelector.holdCallDetails.inCallRefId));
                setInCallNotificationId(notificationsSliceSelector.holdCallDetails.inCallNotificationId);
                setInCallLocationId(notificationsSliceSelector.holdCallDetails.inCallLocationId);
                dispatch(setVideoRoomDetails(notificationsSliceSelector.holdCallDetails.roomData));
                if (notificationsSliceSelector.holdCallDetails.roomData) {
                    setTwilioToken(notificationsSliceSelector.holdCallDetails.roomData.token);
                }
                if (notificationsSliceSelector.holdCallDetails.roomData && notificationsSliceSelector.holdCallDetails.roomData.room_sid) {
                    const callStartedTime = localStorage.getItem(notificationsSliceSelector.holdCallDetails.roomData.room_sid);
                    const currentTimeStamp = Date.now().toString();
                    if (callStartedTime) {
                        const diffTime = (+currentTimeStamp - +callStartedTime!);
                        setInHoldDuration(diffTime);
                    }
                    call_sid = notificationsSliceSelector.holdCallDetails.roomData.room_sid;
                }
                dispatch(setCallAccepted(true));
                dispatch(setHoldCallDetails(undefined));
            }
        } else if (call_type === voice_call_type) {
            dispatch(setAppLoader(true));
            call_sid = checkCallSid(notificationsSliceSelector.holdCallDetails?.callSid);
        }
        socket.emit("resume_call", { call_type: call_type, call_sid: call_sid });
        dispatch(playPauseRinger(false));
    }, [dispatch, notificationsSliceSelector.holdCallDetails, socket])

    const terminateVideoCall = React.useCallback(
        (notificationId: string | undefined, isAutomateTerminate: boolean = false, IsManualCall: string, isTenant?: string | undefined) => {
            if ((notificationsSliceSelector.videoRoomDetails && (notificationId || (!notificationId && isAutomateTerminate))) || (inHoldDuration === undefined && notificationId)) {
                dispatch(setCallAccepted(false));
                setCallTriggeredFlag(false);
                dispatch(setHoldCallDetailsONTenantEnd({ inCallRefId: notificationId, IsManualCall: IsManualCall }));

                // check agent is in hand-off call and remove (hand-off call) if agent end the call
                if (notificationsSliceSelector.inHandOffCall) {
                    dispatch(setInHandOffCall(undefined))
                }

                // checking for manual or server call initiated.
                if (IsManualCall === 'yes') {
                    setFilteredLocationsData((oldArray: any) => {
                        Object.keys(oldArray).forEach((locationType: any) => {
                            let notificationIndex: number = oldArray[locationType].findIndex((location: any) => location._id === notificationId);
                            if (notificationIndex > -1 && oldArray && oldArray[locationType] && oldArray[locationType][notificationIndex]) {
                                let updateNotificationData = { ...oldArray[locationType][notificationIndex] };
                                updateNotificationData.callAccepted = false;
                                oldArray[locationType][notificationIndex] = { ...updateNotificationData };
                            }
                        });
                        return oldArray;
                    })
                } else if (IsManualCall === 'no') {
                    if (notificationId) {
                        dispatch(terminateManualVideoCall(notificationId));
                    }
                }
                if ((notificationId) || (!notificationId && isAutomateTerminate && notificationsSliceSelector.inCallNotificationIdRef)) {
                    setInHoldDuration(undefined);
                    if (notificationId) {
                        removeNotification(notificationId);
                    } else {
                        removeNotification(notificationsSliceSelector.inCallNotificationIdRef);
                    }
                    if (notificationsSliceSelector.videoRoomDetails) {
                        localStorage.removeItem(notificationsSliceSelector.videoRoomDetails?.room_sid);
                    }
                    if (isTenant !== "tenant") {
                        socket.emit("end_call", {
                            kioskId: (notificationsSliceSelector.videoRoomDetails?.kioskId ? notificationsSliceSelector.videoRoomDetails.kioskId : ""),
                            room: notificationsSliceSelector.videoRoomDetails?.roomName,
                            room_sid: notificationsSliceSelector.videoRoomDetails?.room_sid,
                            locationId: inCallLocationId,
                            notificationId: (notificationId && notificationId !== inCallLocationId) ? notificationId : undefined,
                        });
                    }
                    setTwilioToken(null);
                    dispatch(setInCallNotificationIdRef(undefined));
                    dispatch(setInDirectCall(false));
                    setInCallNotificationId(undefined);
                    setInCallLocationId(undefined);
                    dispatch(setVideoRoomDetails(undefined));
                    if (terminateVideoCallRef && terminateVideoCallRef.current) {
                        terminateVideoCallRef.current();
                    }
                }
            }
        },
        [dispatch, inCallLocationId, inHoldDuration, notificationsSliceSelector.inCallNotificationIdRef, notificationsSliceSelector.inHandOffCall, notificationsSliceSelector.videoRoomDetails, socket]
    );

    React.useEffect(() => {
        if (notificationsSliceSelector.videoCallTriggerFlag) {
            terminateVideoCall(
                notificationsSliceSelector.videoCallTriggerFlag.notificationId,
                notificationsSliceSelector.videoCallTriggerFlag.isAutomateTerminate,
                notificationsSliceSelector.videoCallTriggerFlag.IsManualCall ? notificationsSliceSelector.videoCallTriggerFlag.IsManualCall : 'no',
                notificationsSliceSelector.videoCallTriggerFlag.isTenant
            );
            dispatch(triggerVideoCallEndFunction(undefined));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notificationsSliceSelector.videoCallTriggerFlag])

    const destroyVideoCall = React.useCallback(() => {
        terminateVideoCall(undefined, true, '');
    }, [terminateVideoCall])

    React.useEffect(() => {
        return () => {
            if (authState.preventNavigation) {
                destroyVideoCall();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setLocalParticipantInformation = React.useCallback(
        (localParticipantInfo: any) => {
            setLocalParticipantDetails(localParticipantInfo);
        },
        [setLocalParticipantDetails]
    );

    // Voice call acceptance functionality.
    React.useEffect(() => {
        if (notificationsSliceSelector.inComingCallInstanceTrigger) {
            sendVoiceCallMessage()
        }
    }, [notificationsSliceSelector.inComingCallInstanceTrigger, sendVoiceCallMessage]);

    const [doNotDisturbTime, setDoNotDisturbTime] = React.useState<any>();
    const timeOutTimeMinRef = React.useRef<number>();
    const [doNotDisturbError, setDoNotDisturbError] = React.useState("");

    const onSaveDoNotDisturb = React.useCallback(() => {
        if (!timeOutTimeMinRef.current) {
            setDoNotDisturbError("Enter value between 1 minute to 60 minutes.");
            return false;
        } else if (timeOutTimeMinRef.current && (timeOutTimeMinRef.current <= 0 || timeOutTimeMinRef.current > 60)) {
            setDoNotDisturbError("Value should not be more than 60 minutes.");
            return false;
        } else {
            setShowDndPopUp(false);
            if (socket) {
                socket.emit('dnd_kiosk', {
                    'dnd_time': timeOutTimeMinRef.current,
                    'locationId': dnDLocationID,
                    'notificationId': dnDNotificationID
                }, async (response: any) => { logger("Location int DND", response) });
                dispatch(setCallAccepted(false));
                removeNotification(dnDNotificationID);
            }
        }
    }, [dispatch, dnDLocationID, dnDNotificationID, logger, socket]);

    const onChangeDoNotDisturbField = React.useCallback(
        (event: any) => {
            setDoNotDisturbTime(event.target.value);
            setDoNotDisturbError("");
        },
        [setDoNotDisturbTime]
    );

    React.useEffect(() => {
        timeOutTimeMinRef.current = doNotDisturbTime;
    }, [doNotDisturbTime]);

    React.useEffect(() => {
        let obj: any = {};

        onlineLocations.dndDetails.forEach((element: { [s: string]: unknown; } | ArrayLike<unknown>) => {
            obj[Object.keys(element).toString()] = (+Object.values(element).toString()) - new Date().getTime();
            // dispatch(updateDndList({ locationKey: Object.keys(element).toString(), time: new Date().getTime() - new Date(Object.values(element).toString()).getTime() }))
        });
        dispatch(updateDndList(obj));
    }, [dispatch, onlineLocations]);

    const addThirdPersonToCall = React.useCallback((agentDetails: any) => {
        socket.emit("add_third_participant", agentDetails, async (response: any) => {
            logger(`dashboard add_third_participant response`, response);
            if (response.addParticipant === false && response.message) {
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: response.message ? response.message : "Something went wrong hence unable to add participant!",
                        showDialog: true,
                        timer: '5000'
                    }
                ));
            }
        });
    }, [dispatch, logger, socket]);

    // Sync refs with state for voice call
    React.useEffect(() => {
        voiceCallDetailsDataRef.current = voiceCallDetailsData;
        showVoiceCallCustomerDetailsRef.current = showVoiceCallCustomerDetails;
    }, [voiceCallDetailsData, showVoiceCallCustomerDetails]);

    // Detect when voice call ends and handle 15-second window with auto-submit
    React.useEffect(() => {
        const hasActiveVoiceCall = !!(
            notificationsSliceSelector.audioNotificationData ||
            notificationsSliceSelector.outBoundCallLocationDetails ||
            notificationsSliceSelector.agentToAgentOutBoundVoiceCallAgentDetails
        );

        // Call is active - reset the trigger flag and countdown
        if (hasActiveVoiceCall) {
            voiceCallEndTriggeredRef.current = false;
            setVoiceCallCountdown(0);
            if (voiceCallCountdownIntervalRef.current) {
                clearInterval(voiceCallCountdownIntervalRef.current);
                voiceCallCountdownIntervalRef.current = undefined;
            }
            return;
        }

        // Call ended - AudioRooms will unmount
        if (!hasActiveVoiceCall && voiceCallDetailsDataRef.current && !voiceCallEndTriggeredRef.current) {
            // Mark that we've triggered the end behavior
            voiceCallEndTriggeredRef.current = true;

            // Check if already submitted during the call
            const isAlreadySubmitted = voiceCallCustomerDetailsRef.current?.getIsSubmitted();

            // Check if popup was cancelled during the call
            const wasCancelledDuringCall = voiceCallCustomerDetailsRef.current?.getIsCancelledDuringCall();

            // Open popup if NOT already submitted OR if it was cancelled during call
            // This ensures popup reopens even if user cancelled it during the call
            if (!isAlreadySubmitted && (!showVoiceCallCustomerDetailsRef.current || wasCancelledDuringCall)) {
                setShowVoiceCallCustomerDetails(true);
                // Reset the cancelled flag since we're reopening
                if (wasCancelledDuringCall) {
                    voiceCallCustomerDetailsRef.current?.resetCancelledDuringCall();
                }
            }

            // If not submitted, set up 60-second auto-submit timer with countdown
            if (!isAlreadySubmitted) {
                // Start countdown at 60 seconds
                setVoiceCallCountdown(60);

                // Update countdown every second
                voiceCallCountdownIntervalRef.current = setInterval(() => {
                    setVoiceCallCountdown((prev) => {
                        if (prev <= 1) {
                            if (voiceCallCountdownIntervalRef.current) {
                                clearInterval(voiceCallCountdownIntervalRef.current);
                                voiceCallCountdownIntervalRef.current = undefined;
                            }
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);

                // Timer to auto-submit after 60 seconds and then close popup
                voiceCallAutoSubmitTimerRef.current = setTimeout(async () => {
                    console.log('60 seconds elapsed, auto-submitting customer details...');
                    if (voiceCallCustomerDetailsRef.current) {
                        try {
                            await voiceCallCustomerDetailsRef.current.autoSubmit();
                            console.log('Auto-submit completed successfully');
                        } catch (error) {
                            console.error('Auto-submit failed:', error);
                        }
                    }
                    // Close popup after auto-submit
                    setShowVoiceCallCustomerDetails(false);
                    setVoiceCallCountdown(0);

                    // Clear data and reset flags after auto-submit
                    setVoiceCallDetailsData(null);
                    voiceCallEndTriggeredRef.current = false;
                    // Reset cancelled flag in case it was set
                    voiceCallCustomerDetailsRef.current?.resetCancelledDuringCall();
                }, 60000); // 60 seconds

                // No longer need the 20-second timer since we clear immediately after auto-submit

                return () => {
                    if (voiceCallAutoSubmitTimerRef.current) {
                        clearTimeout(voiceCallAutoSubmitTimerRef.current);
                    }
                    if (voiceCallCountdownIntervalRef.current) {
                        clearInterval(voiceCallCountdownIntervalRef.current);
                        voiceCallCountdownIntervalRef.current = undefined;
                    }
                };
            } else {
                // Already submitted - clear data immediately
                setVoiceCallCountdown(0);
                setVoiceCallDetailsData(null);
                voiceCallEndTriggeredRef.current = false;
            }
        }
    }, [
        notificationsSliceSelector.audioNotificationData,
        notificationsSliceSelector.outBoundCallLocationDetails,
        notificationsSliceSelector.agentToAgentOutBoundVoiceCallAgentDetails
    ]);

    // Handler for opening/updating voice call customer details popup
    const handleVoiceCallCustomerDetailsChange = React.useCallback((isOpen: boolean, data?: any) => {
        setShowVoiceCallCustomerDetails(isOpen);
        if (data) {
            // Clear any previous timer when new call starts
            if (voiceCallPopupTimerRef.current) {
                clearTimeout(voiceCallPopupTimerRef.current);
                voiceCallPopupTimerRef.current = undefined;
            }
            setVoiceCallDetailsData(data);
        }
    }, []);

    // Handler for closing voice call customer details popup
    // When cancel is clicked during countdown, submit happens immediately in child component
    // Then this handler is called - we need to clear all timers immediately
    const handleCloseVoiceCallCustomerDetails = React.useCallback((cancelledDuringCall?: boolean) => {
        // Clear all timers immediately (FIX Issue #4: Multiple timers)
        if (voiceCallPopupTimerRef.current) {
            clearTimeout(voiceCallPopupTimerRef.current);
            voiceCallPopupTimerRef.current = undefined;
        }
        if (voiceCallAutoSubmitTimerRef.current) {
            clearTimeout(voiceCallAutoSubmitTimerRef.current);
            voiceCallAutoSubmitTimerRef.current = undefined;
        }
        if (voiceCallClearDataTimerRef.current) {
            clearTimeout(voiceCallClearDataTimerRef.current);
            voiceCallClearDataTimerRef.current = undefined;
        }
        if (voiceCallCountdownIntervalRef.current) {
            clearInterval(voiceCallCountdownIntervalRef.current);
            voiceCallCountdownIntervalRef.current = undefined;
        }

        setShowVoiceCallCustomerDetails(false);
        setVoiceCallCountdown(0);

        // If cancelled during active call, preserve data so popup can reopen after call ends
        // Otherwise clear everything (submit/cancel after call ended, or normal close)
        if (!cancelledDuringCall) {
            setVoiceCallDetailsData(null);
            voiceCallEndTriggeredRef.current = false;
            voiceCallCustomerDetailsRef.current?.resetCancelledDuringCall();
        }
        // If cancelledDuringCall is true, we preserve voiceCallDetailsData so popup can reopen after call ends
    }, []);

    // Sync refs with state for video call
    React.useEffect(() => {
        videoCallDetailsDataRef.current = videoCallDetailsData;
        showVideoCallCustomerDetailsRef.current = showVideoCallCustomerDetails;
    }, [videoCallDetailsData, showVideoCallCustomerDetails]);

    // Detect when video call ends and handle 15-second window with auto-submit
    React.useEffect(() => {
        const hasActiveVideoCall = !!(notificationsSliceSelector.videoRoomDetails);

        // Call is active - reset the trigger flag and countdown
        if (hasActiveVideoCall) {
            videoCallEndTriggeredRef.current = false;
            setVideoCallCountdown(0);
            if (videoCallCountdownIntervalRef.current) {
                clearInterval(videoCallCountdownIntervalRef.current);
                videoCallCountdownIntervalRef.current = undefined;
            }
            return;
        }

        // Call ended - ZoomVideoRoom will unmount
        if (!hasActiveVideoCall && videoCallDetailsDataRef.current && !videoCallEndTriggeredRef.current) {
            // Mark that we've triggered the end behavior
            videoCallEndTriggeredRef.current = true;

            // Check if already submitted during the call
            const isAlreadySubmitted = videoCallCustomerDetailsRef.current?.getIsSubmitted();

            // Only open popup if NOT already submitted
            if (!isAlreadySubmitted && !showVideoCallCustomerDetailsRef.current) {
                setShowVideoCallCustomerDetails(true);
            }

            // If not submitted, set up 60-second auto-submit timer with countdown
            if (!isAlreadySubmitted) {
                // Start countdown at 60 seconds
                setVideoCallCountdown(60);

                // Update countdown every second
                videoCallCountdownIntervalRef.current = setInterval(() => {
                    setVideoCallCountdown((prev) => {
                        if (prev <= 1) {
                            if (videoCallCountdownIntervalRef.current) {
                                clearInterval(videoCallCountdownIntervalRef.current);
                                videoCallCountdownIntervalRef.current = undefined;
                            }
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);

                // Timer to auto-submit after 60 seconds and then close popup
                videoCallAutoSubmitTimerRef.current = setTimeout(async () => {
                    console.log('60 seconds elapsed, auto-submitting customer details (video)...');
                    if (videoCallCustomerDetailsRef.current) {
                        try {
                            await videoCallCustomerDetailsRef.current.autoSubmit();
                            console.log('Auto-submit completed successfully (video)');
                        } catch (error) {
                            console.error('Auto-submit failed (video):', error);
                        }
                    }
                    // Close popup after auto-submit
                    setShowVideoCallCustomerDetails(false);
                    setVideoCallCountdown(0);

                    // Clear data and reset flags after auto-submit
                    setVideoCallDetailsData(null);
                    videoCallEndTriggeredRef.current = false;
                    // Reset cancelled flag in case it was set
                    videoCallCustomerDetailsRef.current?.resetCancelledDuringCall();
                }, 60000); // 60 seconds

                // No longer need the separate clear data timer since we clear immediately after auto-submit

                return () => {
                    if (videoCallAutoSubmitTimerRef.current) {
                        clearTimeout(videoCallAutoSubmitTimerRef.current);
                    }
                    if (videoCallCountdownIntervalRef.current) {
                        clearInterval(videoCallCountdownIntervalRef.current);
                        videoCallCountdownIntervalRef.current = undefined;
                    }
                };
            } else {
                // Already submitted - clear data immediately
                setVideoCallCountdown(0);
                setVideoCallDetailsData(null);
                videoCallEndTriggeredRef.current = false;
            }
        }
    }, [
        notificationsSliceSelector.videoRoomDetails
    ]);

    // Handler for opening/updating video call customer details popup
    const handleVideoCallCustomerDetailsChange = React.useCallback((isOpen: boolean, data?: any) => {
        setShowVideoCallCustomerDetails(isOpen);
        if (data) {
            // Clear any previous timer when new call starts
            if (videoCallPopupTimerRef.current) {
                clearTimeout(videoCallPopupTimerRef.current);
                videoCallPopupTimerRef.current = undefined;
            }
            setVideoCallDetailsData(data);
        }
    }, []);

    // Handler for closing video call customer details popup
    // When cancel is clicked during countdown, submit happens immediately in child component
    // Then this handler is called - we need to clear all timers immediately
    const handleCloseVideoCallCustomerDetails = React.useCallback((cancelledDuringCall?: boolean) => {
        // Clear all timers immediately (FIX Issue #4: Multiple timers)
        if (videoCallPopupTimerRef.current) {
            clearTimeout(videoCallPopupTimerRef.current);
            videoCallPopupTimerRef.current = undefined;
        }
        if (videoCallAutoSubmitTimerRef.current) {
            clearTimeout(videoCallAutoSubmitTimerRef.current);
            videoCallAutoSubmitTimerRef.current = undefined;
        }
        if (videoCallClearDataTimerRef.current) {
            clearTimeout(videoCallClearDataTimerRef.current);
            videoCallClearDataTimerRef.current = undefined;
        }
        if (videoCallCountdownIntervalRef.current) {
            clearInterval(videoCallCountdownIntervalRef.current);
            videoCallCountdownIntervalRef.current = undefined;
        }

        setShowVideoCallCustomerDetails(false);
        setVideoCallCountdown(0);

        // If cancelled during active call, preserve data so popup can reopen after call ends
        // Otherwise clear everything (submit/cancel after call ended, or normal close)
        if (!cancelledDuringCall) {
            setVideoCallDetailsData(null);
            videoCallEndTriggeredRef.current = false;
            videoCallCustomerDetailsRef.current?.resetCancelledDuringCall();
        }
        // If cancelledDuringCall is true, we preserve videoCallDetailsData so popup can reopen after call ends
    }, []);

    return (
        <>
            {
                (showDndPopUp) ?
                    <AppModal
                        title={"Do Not Disturb"}
                        bodyText={"How long you would like to set the Location in `Do Not Disturb` mode?"}
                        showCloseButton={true}
                        closeButtonEventEmitter={() => { setShowDndPopUp(false); setDoNotDisturbError(""); }}
                        primaryButtonLabel={"Save"}
                        primaryButtonEventEmitter={() => onSaveDoNotDisturb()}
                        secondaryButtonLabel={"Cancel"}
                        secondaryButtonEventEmitter={() => {
                            setShowDndPopUp(false);
                            setDoNotDisturbError("");
                        }}
                        stayAppear={true}
                    >
                        {/* <Teams addAgentModel={true} /> */}

                        <Form className="mt-2">
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlInput1"
                            >
                                <div className="row">
                                    <div className="col">
                                        <Form.Control
                                            type="text"
                                            onChange={onChangeDoNotDisturbField}
                                            onKeyPress={numberOnly}
                                        />
                                    </div>
                                    <div className="col mt-1">
                                        <Form.Label>minutes</Form.Label>
                                    </div>
                                </div>
                                <p className="text-danger">{doNotDisturbError}</p>
                            </Form.Group>
                        </Form>
                    </AppModal>
                    :
                    <></>
            }
            <Container fluid className="row inner-body-section">
                {notificationsSliceSelector.appLoader ? <AppLoader removeFixedHeight={true} customClassName={"spinner-fixed-blocked"} /> : <></>}

                <div className="col-lg-6 fixed_div">
                    <div className="notification-scrollbar-primary">
                        <Accordion
                            key={notificationsSliceSelector.defaultActiveKeys.length}
                            defaultActiveKey={notificationsSliceSelector.defaultActiveKeys}
                            alwaysOpen
                            onSelect={(eventKey: any) => {
                                if (!(eventKey && eventKey.includes("0"))) {
                                    dispatch(setDefaultActiveKeys([...eventKey]));
                                }
                            }}
                        >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <h4>
                                        <b>Incoming Notification</b>
                                    </h4>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <>
                                        {
                                            <>
                                                {notificationsSliceSelector.notificationData &&
                                                    notificationsSliceSelector.notificationData.length ? (
                                                    <div className="">
                                                        {
                                                            (notificationsSliceSelector.notificationData.map(
                                                                (
                                                                    item: DtoIncomingNotification,
                                                                    i: number
                                                                ) => (
                                                                    <div
                                                                        key={
                                                                            i +
                                                                            item.locationId +
                                                                            item.notificationId
                                                                        }
                                                                    >
                                                                        {notificationsSliceSelector.locationDetails ? (
                                                                            <LocationDetailsCard
                                                                                key={
                                                                                    i +
                                                                                    item.locationId +
                                                                                    item.notificationId
                                                                                }
                                                                                localParticipantDetails={
                                                                                    localParticipantDetails
                                                                                }
                                                                                agentStatus={agentStatus}
                                                                                locationInformation={
                                                                                    notificationsSliceSelector.locationDetails[
                                                                                    item
                                                                                        .locationId
                                                                                    ]
                                                                                }
                                                                                notificationData={
                                                                                    item
                                                                                }
                                                                                terminateVideoCall={
                                                                                    terminateVideoCall
                                                                                }
                                                                                restartMotionDetection={
                                                                                    restartMotionDetection
                                                                                }
                                                                                sendMessage={
                                                                                    sendMessage
                                                                                }
                                                                                stopNotificationRing={
                                                                                    stopNotificationRing
                                                                                }
                                                                                inCallRef={
                                                                                    notificationsSliceSelector.inCallNotificationIdRef
                                                                                }
                                                                                onlineLocations={
                                                                                    onlineLocations
                                                                                }
                                                                                acceptVoiceCall={
                                                                                    acceptIncomingVoiceCall
                                                                                }
                                                                                getUserMediaDetails={
                                                                                    getUserMediaDetails
                                                                                }
                                                                                incomingNotificationData={
                                                                                    notificationsSliceSelector.notificationData
                                                                                }
                                                                                putCallOnHold={
                                                                                    putCallOnHold
                                                                                }
                                                                                resumeVideoCall={
                                                                                    resumeVideoCall
                                                                                }
                                                                                showDndModal={showDndModal}
                                                                                dndTime={notificationsSliceSelector.dndTimer}
                                                                                callTriggeredFlag={
                                                                                    callTriggeredFlag
                                                                                }
                                                                                setCallTriggeredFlag={
                                                                                    setCallTriggeredFlag
                                                                                }
                                                                                currentAgentId={
                                                                                    agentId
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                    </div>
                                                                )
                                                            ))
                                                        }
                                                    </div>
                                                ) : (
                                                    <p className="m-2 text-center">
                                                        No incoming notification.
                                                    </p>
                                                )}
                                            </>
                                        }
                                    </>

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <h4>
                                        <b>Primary Locations</b>
                                    </h4>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <>
                                        {
                                            <>
                                                {filteredLocationsData &&
                                                    filteredLocationsData.primary.length > 0 ? (
                                                    <div className="notification-scrollbar-secondary">
                                                        {
                                                            (filteredLocationsData.primary.map(
                                                                (item: any, i: number) => {
                                                                    return (
                                                                        <LocationDetailsCard
                                                                            key={item._id + i}
                                                                            locationInformation={
                                                                                item
                                                                            }
                                                                            agentStatus={agentStatus}
                                                                            localParticipantDetails={
                                                                                localParticipantDetails
                                                                            }
                                                                            terminateVideoCall={
                                                                                terminateVideoCall
                                                                            }
                                                                            restartMotionDetection={
                                                                                restartMotionDetection
                                                                            }
                                                                            sendMessage={
                                                                                sendMessage
                                                                            }
                                                                            stopNotificationRing={
                                                                                stopNotificationRing
                                                                            }
                                                                            inCallRef={notificationsSliceSelector.inCallNotificationIdRef}
                                                                            onlineLocations={
                                                                                onlineLocations
                                                                            }
                                                                            getUserMediaDetails={
                                                                                getUserMediaDetails
                                                                            }
                                                                            incomingNotificationData={
                                                                                notificationsSliceSelector.notificationData
                                                                            }
                                                                            putCallOnHold={
                                                                                putCallOnHold
                                                                            }
                                                                            resumeVideoCall={
                                                                                resumeVideoCall
                                                                            }
                                                                            showDndModal={showDndModal}
                                                                            dndTime={notificationsSliceSelector.dndTimer}
                                                                            callTriggeredFlag={
                                                                                callTriggeredFlag
                                                                            }
                                                                            setCallTriggeredFlag={
                                                                                setCallTriggeredFlag
                                                                            }
                                                                            currentAgentId={
                                                                                agentId
                                                                            }
                                                                        />
                                                                    );
                                                                }
                                                            ))
                                                        }
                                                    </div>
                                                ) : (
                                                    <p className="m-2 text-center">
                                                        No Primary locations available
                                                    </p>
                                                )}
                                            </>
                                        }
                                    </>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2" >
                                <Accordion.Header>
                                    <h4>
                                        <b>Secondary Locations</b>
                                    </h4>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <>
                                        {
                                            <>
                                                {filteredLocationsData &&
                                                    filteredLocationsData.secondary.length >
                                                    0 ? (
                                                    <div className="notification-scrollbar-secondary">
                                                        {
                                                            (filteredLocationsData.secondary.map(
                                                                (item: any, i: number) => {
                                                                    return (
                                                                        <LocationDetailsCard
                                                                            key={item._id + i}
                                                                            locationInformation={
                                                                                item
                                                                            }
                                                                            agentStatus={agentStatus}
                                                                            localParticipantDetails={
                                                                                localParticipantDetails
                                                                            }
                                                                            terminateVideoCall={
                                                                                terminateVideoCall
                                                                            }
                                                                            restartMotionDetection={
                                                                                restartMotionDetection
                                                                            }
                                                                            sendMessage={
                                                                                sendMessage
                                                                            }
                                                                            stopNotificationRing={
                                                                                stopNotificationRing
                                                                            }
                                                                            inCallRef={
                                                                                notificationsSliceSelector.inCallNotificationIdRef
                                                                            }
                                                                            onlineLocations={
                                                                                onlineLocations
                                                                            }
                                                                            getUserMediaDetails={
                                                                                getUserMediaDetails
                                                                            }
                                                                            incomingNotificationData={
                                                                                notificationsSliceSelector.notificationData
                                                                            }
                                                                            putCallOnHold={
                                                                                putCallOnHold
                                                                            }
                                                                            resumeVideoCall={
                                                                                resumeVideoCall
                                                                            }
                                                                            showDndModal={showDndModal}
                                                                            dndTime={notificationsSliceSelector.dndTimer}
                                                                            callTriggeredFlag={
                                                                                callTriggeredFlag
                                                                            }
                                                                            setCallTriggeredFlag={
                                                                                setCallTriggeredFlag
                                                                            }
                                                                            currentAgentId={
                                                                                agentId
                                                                            }
                                                                        />
                                                                    );
                                                                }
                                                            ))
                                                        }
                                                    </div>
                                                ) : (
                                                    <p className="m-2 text-center">
                                                        No Secondary locations available
                                                    </p>
                                                )}
                                            </>
                                        }
                                    </>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    <h4>
                                        <b>Other Locations</b>
                                    </h4>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <>
                                        {
                                            <>
                                                {filteredLocationsData &&
                                                    filteredLocationsData.others.length > 0 ? (
                                                    <div className="notification-scrollbar-secondary">
                                                        {
                                                            (filteredLocationsData.others.map(
                                                                (item: any, i: number) => {
                                                                    return (
                                                                        <LocationDetailsCard
                                                                            key={item._id + i}
                                                                            locationInformation={
                                                                                item
                                                                            }
                                                                            agentStatus={agentStatus}
                                                                            localParticipantDetails={
                                                                                localParticipantDetails
                                                                            }
                                                                            terminateVideoCall={
                                                                                terminateVideoCall
                                                                            }
                                                                            restartMotionDetection={
                                                                                restartMotionDetection
                                                                            }
                                                                            sendMessage={
                                                                                sendMessage
                                                                            }
                                                                            stopNotificationRing={
                                                                                stopNotificationRing
                                                                            }
                                                                            inCallRef={
                                                                                notificationsSliceSelector.inCallNotificationIdRef
                                                                            }
                                                                            onlineLocations={
                                                                                onlineLocations
                                                                            }
                                                                            getUserMediaDetails={
                                                                                getUserMediaDetails
                                                                            }
                                                                            incomingNotificationData={
                                                                                notificationsSliceSelector.notificationData
                                                                            }
                                                                            putCallOnHold={
                                                                                putCallOnHold
                                                                            }
                                                                            resumeVideoCall={
                                                                                resumeVideoCall
                                                                            }
                                                                            showDndModal={showDndModal}
                                                                            dndTime={notificationsSliceSelector.dndTimer}
                                                                            callTriggeredFlag={
                                                                                callTriggeredFlag
                                                                            }
                                                                            setCallTriggeredFlag={
                                                                                setCallTriggeredFlag
                                                                            }
                                                                            currentAgentId={
                                                                                agentId
                                                                            }
                                                                        />
                                                                    );
                                                                }
                                                            ))
                                                        }
                                                    </div>
                                                ) : (
                                                    <p className="m-2 text-center">
                                                        No Other locations available
                                                    </p>
                                                )}
                                            </>
                                        }
                                    </>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>

                <div className="col-lg-6 dashboard-video-container" id="videocontainer">
                    <div className="meetingPanel">
                        <div
                            className={(twilioToken || notificationsSliceSelector.audioNotificationData) ? "camscreen" : "logo  px-2"}
                        >
                            {
                                ((twilioToken && zoomVideoRoomName) || (twilioToken && notificationsSliceSelector.videoRoomDetails)) && (
                                    !checkAbilityToUseZOOM() ?
                                        <VideoRoom
                                            setLocalParticipantInfo={
                                                setLocalParticipantInformation
                                            }
                                            roomName={notificationsSliceSelector.videoRoomDetails ? notificationsSliceSelector.videoRoomDetails.roomName : ''}
                                            roomSid={notificationsSliceSelector.videoRoomDetails ? notificationsSliceSelector.videoRoomDetails.room_sid : ''}
                                            addParticipant={notificationsSliceSelector.videoRoomDetails ? notificationsSliceSelector.videoRoomDetails.addParticipant : false}
                                            twilioToken={twilioToken}
                                            locationId={inCallLocationId!}
                                            notificationId={inCallNotificationId!}
                                            terminateVideoCall={terminateVideoCall}
                                            terminateVideoCallRef={terminateVideoCallRef}
                                            holdVideoCallRef={holdVideoCallRef}
                                            putCallOnHold={putCallOnHold}
                                            inHoldDuration={inHoldDuration}
                                            agentId={agentId}
                                            addParticipantVideoCall={(roomName, agentDetails, locationId, roomSid, isQrScanNotification) => { addParticipantVideoCall(roomName, agentDetails, locationId, roomSid, isQrScanNotification, ""); dispatch(updateVideoRoomDetailsAddParticipantButton({ locationId: notificationsSliceSelector.videoRoomDetails?.locationId, roomSid: notificationsSliceSelector.videoRoomDetails?.room_sid, condition: false })); }}
                                            isQrScanNotification={isQrScanNotification}
                                        /> :
                                        <ZoomVideoRoom
                                            setLocalParticipantInfo={
                                                setLocalParticipantInformation
                                            }
                                            twilioToken={twilioToken}
                                            roomName={notificationsSliceSelector.videoRoomDetails ? notificationsSliceSelector.videoRoomDetails.roomName : zoomVideoRoomName}
                                            roomSid={notificationsSliceSelector.videoRoomDetails ? notificationsSliceSelector.videoRoomDetails.room_sid : ''}
                                            terminateVideoCallRef={terminateVideoCallRef}
                                            terminateVideoCall={terminateVideoCall}
                                            holdVideoCallRef={holdVideoCallRef}
                                            putCallOnHold={putCallOnHold}
                                            inHoldDuration={inHoldDuration}
                                            locationId={inCallLocationId}
                                            notificationId={inCallNotificationId!}
                                            addParticipant={notificationsSliceSelector.videoRoomDetails ? notificationsSliceSelector.videoRoomDetails.addParticipant : false}
                                            addParticipantVideoCall={(roomName: any, agentDetails: any, locationId: any, roomSid: any, isQrScanNotification: any) => { addParticipantVideoCall(roomName, agentDetails, locationId, roomSid, isQrScanNotification, notificationsSliceSelector?.notificationData[0]?.sessionName ? notificationsSliceSelector?.notificationData[0]?.sessionName : ""); dispatch(updateVideoRoomDetailsAddParticipantButton({ locationId: notificationsSliceSelector.videoRoomDetails?.locationId, roomSid: notificationsSliceSelector.videoRoomDetails?.room_sid, condition: false })); }}
                                            isQrScanNotification={isQrScanNotification}
                                            sessionName={notificationsSliceSelector.videoRoomDetails ? notificationsSliceSelector.videoRoomDetails.roomName : zoomVideoRoomName}
                                            agentId={agentId}
                                            userName={agentId} // need to change
                                            onCustomerDetailsChange={handleVideoCallCustomerDetailsChange}
                                            videoCallCustomerDetailsRef={videoCallCustomerDetailsRef}
                                        />
                                )
                            }
                            {
                                (!twilioToken && !notificationsSliceSelector.audioNotificationData && agentLogo && !notificationsSliceSelector.outBoundCallLocationDetails && !notificationsSliceSelector.agentToAgentOutBoundVoiceCallAgentDetails && !showLoader) ? (
                                    <img
                                        src={agentLogo}
                                        className="vrm_large_logo"
                                        alt="temp"
                                    />
                                ) : (
                                    (showLoader) ?
                                        <AppLoader removeFixedHeight={true} />
                                        :
                                        <></>
                                )
                            }
                            {
                                (notificationsSliceSelector.audioNotificationData || notificationsSliceSelector.outBoundCallLocationDetails || notificationsSliceSelector.agentToAgentOutBoundVoiceCallAgentDetails) && (
                                    <AudioRooms
                                        TenantNotificationDetails={notificationsSliceSelector.audioNotificationData}
                                        inBoundCallConnection={notificationsSliceSelector.callDetails}
                                        outBoundCallLocationDetails={notificationsSliceSelector.outBoundCallLocationDetails}
                                        inCallNotificationIdRef={notificationsSliceSelector.inCallNotificationIdRef}
                                        twilioDevice={notificationsSliceSelector.device}
                                        voiceAudioMute={notificationsSliceSelector.voiceCallAudioMute}
                                        outBoundCallPhoneNumber={notificationsSliceSelector.outBoundCallPhoneNumber}
                                        outBoundCallFromPhoneNumber={notificationsSliceSelector.outBoundCallFromPhoneNumber}
                                        audioCallTimer={notificationsSliceSelector.audioCallTimer}
                                        sendOutBoundVoiceCallSocketEmit={sendOutBoundVoiceCallSocketEmit}
                                        notificationData={notificationsSliceSelector.notificationData}
                                        outBoundCallConnection={notificationsSliceSelector.outBoundCallConnection}
                                        agentToAgentOutBoundVoiceCallAgentDetails={notificationsSliceSelector.agentToAgentOutBoundVoiceCallAgentDetails}
                                        putCallOnHold={putCallOnHold}
                                        holdCallDetails={notificationsSliceSelector.holdCallDetails}
                                        addThirdPersonToCallHandler={addThirdPersonToCall}
                                        outBoundCallAddParticipant={notificationsSliceSelector.outBoundCallAddParticipant}
                                        outBoundCallCustomerDetails={notificationsSliceSelector.outBoundCallCustomerDetails}
                                        onCustomerDetailsChange={handleVoiceCallCustomerDetailsChange}
                                        voiceCallCustomerDetailsRef={voiceCallCustomerDetailsRef}
                                    />
                                )
                            }
                        </div >
                    </div >
                </div >
            </Container >

            {/* Voice Call Customer Details Popup - Rendered here to persist after AudioRooms unmounts */}
            {/* Keep component mounted even when closed to maintain ref connection for auto-submit */}
            {voiceCallDetailsData && (
                <VoiceCallCustomerDetails
                    ref={voiceCallCustomerDetailsRef}
                    isOpen={showVoiceCallCustomerDetails}
                    onClose={handleCloseVoiceCallCustomerDetails}
                    callSid={voiceCallDetailsData.callSid}
                    existingCustomerDetails={voiceCallDetailsData.existingCustomerDetails}
                    locationId={voiceCallDetailsData.locationId}
                    countdown={voiceCallCountdown}
                />
            )}

            {/* Keep component mounted even when closed to maintain ref connection for auto-submit */}
            {videoCallDetailsData && (
                <VideoCallCustomerDetails
                    ref={videoCallCustomerDetailsRef}
                    isOpen={showVideoCallCustomerDetails}
                    onClose={handleCloseVideoCallCustomerDetails}
                    callSid={videoCallDetailsData.sessionId}
                    locationId={videoCallDetailsData.locationId}
                    countdown={videoCallCountdown}
                />
            )}
        </>
    );
};

export default Dashboard;
